<template>
  <div class="navbar-section">
    <div>
      <div class="navbar">
        <template v-if="userName">
          <div v-if="parseInt($route.params.id) === userId" class="navbar-item navbar-icon" @click="showInsertUser">
            <CustomIcon icon="PLUS" color="success" />
          </div>
          <div v-else class="navbar-item"></div>
          <div class="navbar-item navbar-title">
            {{ name }}
          </div>
          <div class="navbar-item navbar-icon" @click="$router.go(-1)">
            <CustomIcon icon="CHEVRON_LEFT" />
          </div>
        </template>
        <template v-else>
          <div class="navbar-item navbar-title mx-auto">
            {{ $t('users.list.title') }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CustomIcon from '../icon/customIcon'
export default {
  name: 'Navbar',

  props: {
    user: {
      type: Object,
      default: () => {}
    },

    userName: {
      type: String,
      default: () => ''
    },

    showInsertUser: {
      type: Function,
      default: () => function () {}
    }
  },

  components: {
    CustomIcon
  },

  data () {
    return {
      name: ''
    }
  },

  computed: {
    userId () {
      const user = JSON.parse(localStorage.getItem('user'))
      // console.log(user)
      // console.log(this.user)
      if (user.id > 0) {
        return user.id
      }
      return -1
    }
  },

  watch: {
    user: {
      handler (val) {
        this.name = [val.name, val.family]
        this.name = this.name.join(' ')
      },

      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .navbar-section {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    background-color: #fff;
    box-shadow: 0 0 5px #cdcdcd;
    z-index: 12000;

    .navbar {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .navbar-title {
        font-weight: bold;
      }

      .navbar-icon:hover {
        cursor: pointer;
      }
    }
  }

  [dir="ltr"] .navbar {
    flex-direction: row-reverse;
  }
</style>
